import React from "react";

export interface IconProps {
  className?: string;
  size?: number;
}

const paymentIconSrc = (fileName: string) =>
  `${process.env.PUBLIC_URL || ""}/payment/${fileName}`;

export const ShieldCheckIcon: React.FC<IconProps> = ({ className, size = 16 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
  >
    <path
      d="M12 2.5L4.5 5.5V11.5C4.5 16.2 7.6 20.5 12 21.8C16.4 20.5 19.5 16.2 19.5 11.5V5.5L12 2.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 12L10.8 14.3L15.5 9.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckCircleIcon: React.FC<IconProps> = ({ className, size = 16 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
  >
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M8 12L10.8 14.8L16 9.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WechatPayIcon: React.FC<IconProps> = ({ className, size = 40 }) => (
  <img
    src={paymentIconSrc("wxpay_icon.png")}
    alt=""
    className={className}
    width={size}
    height={size}
    draggable={false}
    aria-hidden
  />
);

/** 企业余额（与 buyer-app 同款资源） */
export const EnterprisePayIcon: React.FC<IconProps> = ({ className, size = 40 }) => (
  <img
    src={paymentIconSrc("enterprisepay_icon.png")}
    alt=""
    className={className}
    width={size}
    height={size}
    draggable={false}
    aria-hidden
  />
);

/** @deprecated 使用 EnterprisePayIcon */
export const AlipayIcon = EnterprisePayIcon;

export const CopyIcon: React.FC<IconProps> = ({ className, size = 16 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
  >
    <rect
      x="9"
      y="9"
      width="13"
      height="13"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
